const getTalentAttributes = (boughtTalents, { wearingArmor, baseArmorSoak } = {}) => {
    const result = { soak: 0, armorSoak: 0, defenseRanged: 0, defenseMelee: 0, wound: 0, strain: 0 };
    if (!boughtTalents) { return result; }

    for (const t of boughtTalents) {
        const attrs = t.data?.Attributes;
        if (!attrs) { continue; }
        const count = t.count || 1;
        const needsArmor = attrs.Requirement?.WearingArmor === "true";

        if (attrs.SoakValue) {
            const val = (parseInt(attrs.SoakValue) || 0) * count;
            if (needsArmor) { if (wearingArmor) { result.armorSoak += val; } }
            else { result.soak += val; }
        }
        if (attrs.WoundThreshold) { result.wound += (parseInt(attrs.WoundThreshold) || 0) * count; }
        if (attrs.StrainThreshold) { result.strain += (parseInt(attrs.StrainThreshold) || 0) * count; }
    }

    const effectiveArmorSoak = (parseInt(baseArmorSoak) || 0) + result.armorSoak;

    for (const t of boughtTalents) {
        const attrs = t.data?.Attributes;
        if (!attrs) { continue; }
        const count = t.count || 1;
        const req = attrs.Requirement || {};
        const needsArmor = req.WearingArmor === "true";
        const soakAtLeast = req.SoakAtLeast != null ? parseInt(req.SoakAtLeast) : null;
        const meetsReq =
            (!needsArmor || wearingArmor) &&
            (soakAtLeast == null || effectiveArmorSoak >= soakAtLeast);
        if (!meetsReq) { continue; }

        if (attrs.DefenseRanged) { result.defenseRanged += (parseInt(attrs.DefenseRanged) || 0) * count; }
        if (attrs.DefenseMelee) { result.defenseMelee += (parseInt(attrs.DefenseMelee) || 0) * count; }
    }

    return result;
};

export default getTalentAttributes;
